<template>
  <div id="app">
    <Nav/>
    <el-backtop :bottom="60"></el-backtop>

    <div class="contents">
      <router-view></router-view>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'

export default {
  components: { Nav,Footer }
}
</script>

<style lang="less" scoped>
.contents{margin: auto;padding-top: 0px;min-height: 200px;}
</style>
